import { Component, OnInit, Input } from '@angular/core';

import * as routingAction from '../../store/actions/routing.actions';
import * as fromRoutingReducer from '../../store/reducers/routing.reducer';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { RecentRoute } from '../../models/RecentRoutes';
import { getRecentRoutes } from '../../store/reducers';

@Component({
  selector: 'app-recent-routes',
  templateUrl: './recent-routes.component.html',
  styleUrls: ['./recent-routes.component.scss'],
})
export class RecentRoutesComponent implements OnInit {
  recents$: Observable<RecentRoute[]> = this.store.pipe(
    select(getRecentRoutes),
  );
  @Input() inHeader = false;

  constructor(private store: Store<fromRoutingReducer.RoutingState>) {}

  ngOnInit() {
    this.store.dispatch(new routingAction.FetchRecentRoutes());
  }
}
